let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1DGap")).then(() => parcelRequire('dpuyx'));